import React, { useEffect, useState, useCallback, useMemo } from 'react';
import { Container, Row, Col, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { getAdminConfiguration, putAdminConfiguration } from '../apis/adminApi';
import { PurgeJobs } from "../components/Admin/Purge";
import { FormattedConfig } from '../components/Admin/FormattedConfig';

export const AdminPage = () => 
{
    const today = useMemo(() => new Date().toISOString().split('T')[0], []);
    
    const [adminConfig, setAdminConfig] = useState(null);
    const [alert, setAlert] = useState(null);
    const [authorized, setAuthorized] = useState(true);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        async function fetchAdminConfig() {
            try {

                const response = await getAdminConfiguration();
                
                if (response.config === null) {
                    setAlert({ message: response.message, variant: "warning" });
                } else if (Object.keys(response.config).length === 0) {
                    setAlert({ message: "No Configuration Settings Are Currently Available.", variant: "info" });
                } else {
                    
                    setAdminConfig(response.config);
                }
            } catch (error) { 
                if (error.status === 403) {
                    setAuthorized(false);
                } else {
                    setAlert({ message: "Failed To Fetch Admin Configuration. Please Try Again Later.", variant: "danger" });
                }
            } finally {
                setLoading(false);
            }
        }
        fetchAdminConfig(); 
    }, []);



    const validJson = (str) => {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }

    
    if (!authorized) {
        return (
            <Alert variant="danger">
                You do not have permission to access settings.
            </Alert>
        );
    }

    if (loading) {
        return (
            <div className="admin-header text-center">
                <Spinner animation="border" role="status" />
                <h3 className="display-5 mt-3">Loading Settings...</h3>
            </div>
        );
    }

    return (
        <>
            {alert && (
                <Alert variant={alert.variant} dismissible onClose={() => setAlert(null)}>
                    {alert.message}
                </Alert>
            )}
            {adminConfig ? (
                <Container fluid className="p-5 rounded-3">
                    {Object.entries(adminConfig).map(([config, settings]) => (
                        <FormattedConfig key={config} configEntryLabel={config} configValues={settings} today={today} setAlert={setAlert}/>
                    ))}
                    <hr/>
                    <PurgeJobs />
                </Container>
            ) : null}
        </>
    );
}